import React from 'react';

const AboutUs = () => {
  return (
    <section id="about" className="about-us">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <div className="section-subtitle">O firmie</div>
            <h2>Eksperci w Pozyskiwaniu Finansowania</h2>
            <p>
              Od ponad 8 lat pomagamy organizacjom pozarządowym, samorządom i przedsiębiorstwom 
              w skutecznym pozyskiwaniu środków zewnętrznych. Nasze doświadczenie i znajomość 
              procedur grantowych przekładają się na najwyższy wskaźnik sukcesu w branży.
            </p>
            <p>
              Nie tylko piszemy wnioski - budujemy długotrwałe partnerstwa, dzieląc się 
              wiedzą i wspierając naszych klientów na każdym etapie realizacji projektów.
            </p>
            
            <div className="about-features">
              <div className="about-feature">
                <i className="fas fa-check-circle"></i>
                <span>Certyfikowani eksperci</span>
              </div>
              <div className="about-feature">
                <i className="fas fa-check-circle"></i>
                <span>Indywidualne podejście</span>
              </div>
              <div className="about-feature">
                <i className="fas fa-check-circle"></i>
                <span>Kompleksowa obsługa</span>
              </div>
              <div className="about-feature">
                <i className="fas fa-check-circle"></i>
                <span>Gwarancja jakości</span>
              </div>
            </div>
          </div>
          
          <div className="about-image">
            <i className="fas fa-users" style={{ fontSize: '4rem' }}></i>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
